import React from 'react';
import { PopOver, OverlayTrigger } from '@tencent/spaui';
import { REGEXP } from '@/constants/regexp';
import {
  FILTER_TEMPLATE,
  BUYING_TYPE_LIST,
  BUYING_TYPE_FAST_LIST,
  CUSTOMER_STATUS_LIST,
  FORBIDDEN_CREATE_AD_STATUS,
  MERGED_STATUS_LIST,
  COLLOCATION_STATUS_LIST,
  BALANCE_STATUS_LIST,
  OPERATION_LABEL_LIST,
  PAY_TYPE_LIST,
  AUTO_TRANSFER_VALID_LIST,
  IS_COLLECT_ADVERTISER_LIST,
  PREDICT_REMAIN_DAYS_LIST,
  OPERATION_OBJECT_TYPE_LIST,
  OPERATION_TYPE_LIST,
  FINANCE_OPERATION_MP_AD_LIST,
  FINANCE_OPERATION_MP_AGENCY_LIST,
  FINANCERECORDTYPES_LIST,
  FINANCE_OPERATION_TYPE_LIST,
  FINANCE_INOUT_TYPES,
  EMPLOYEE_STATUS_LIST,
  EMPLOYEE_TYPE_LIST,
  IMPRESSION_AFFACTION_LEVEL,
  DERIVE_STATUS_LIST,
  BOOL_LIST,
  MERGE_FUND_TYPE_LIST,
  INACTIVE_DAYS_LIST,
  IS_LOCAL_BUSINESS_LIST,
  K_FRAME_LIST,
  COST_TYPE_LIST,
  FINANCE_OPERATION_TYPE_SHARED_WALLET_LIST,
  AUTHORIZE_TYPE_LIST,
  PAID_TYPE_LIST,
} from './constants';
import { SHORTCUTSCONFIG, SHORTCUTSCONFIG2 } from '@/constants/reportField';
import { getQTDList } from '@/constants/quarterConfig';
import { SelectionDataComponent } from '@/components/AccountSelect';

import { getIndustryList, getOperatorList, getAreaCodeList } from '@/api/operator/cgi/smb/account/gdt';
import { getPunishmentConfig } from '@/pages/agency/manage/punishment-list/api';
import { getIndustry } from '@/pages/agency/utils/industry';
import { getAreaInfo } from '@/pages/agency/utils/area';
import { getSaleOrganizationTree, getSaleEmployeeList } from '@/pages/agency/manage/operation-log/api';
import { getRoleList, getOrganizationList } from '@/pages/organization/employee/api';
import { getBmList } from '@/api/operator/cgi/smb/common/index';
import { getProductTypeList, getPlacementGroupList, getPositionList } from '@/api/operator/cgi/smb/report/report';
import { getSpuCategoryList } from '@/pages/agency/task/dashboard/api';
import { getMdmList, getBusinessUnitList } from '@/pages/agency/assets/creative-material/api';
import { getRainbowCommonConfig } from '@/api/rainbow';
import _ from 'lodash';
import dayjs from 'dayjs';
import globalStore from '@/stores';

import filterRebate from './rebate';
import filterSales from './sales';
import filterDistribution from './distribution';
import filterTask, { convertSpuCategoryList } from './task';
import filterManage from './manage';
import filterReport from './report';
import filterCreative from './creative';
import filterGrowup from './growup';
import { AgencyType } from '@/model/agency';
import { getQuarterList } from '@/utils/date';

const date = dayjs();

export const BASE_FILTER_MAP: any = {
  agency_uid: {
    name: 'agency_uid',
    title: '所属服务商',
    type: 'select',
    config: {
      className: 'agency-select',
      SelectionDataComponent,
      search: true,
      searchFields: ['label', 'value'],
    },
  },
  agency_uid_list: {
    name: 'agency_uid_list',
    title: '所属服务商',
    type: 'select',
    config: {
      className: 'agency-select',
      SelectionDataComponent,
      multiple: true,
      checkAll: true,
      checkAllLabel: '全部账户',
      search: true,
      searchFields: ['label', 'value'],
    },
  },
  mdm_id: {
    title: '客户名称',
    name: 'mdm_id',
    type: 'select',
    config: {
      data: [], // 接口依赖agency_uid，需页面联动
      placeholder: '请先选择所属服务商',
      fetchData: (params: any) => {
        if (!params.agency_uid) {
          return Promise.resolve({
            code: 0,
            data: [],
          });
        }
        return getMdmList({
          ...params,
          page: 1,
          page_size: 20,
        });
      },
      convertData: (res: any) => {
        return (res?.data?.list || []).map((v: any) => ({
          value: v.mdm_id,
          label: v.mdm_name ? `${v.mdm_name}(${v.mdm_id})` : v.mdm_id,
        }));
      },
      search: true,
      getSearchParams: (keywords: any) => ({ mdm_name_fuzzy: keywords }),
    },
  },
  uname: {
    name: 'uname',
    title: '账户名称',
    type: 'search',
    config: {
      placeholder: '请输入账户名称',
    },
  },
  wechat_uname: {
    name: 'wechat_uname',
    title: '公众号名称',
    type: 'search',
    config: {
      placeholder: '请输入公众号名称',
    },
  },
  industry_id_list: {
    name: 'industry_id_list',
    title: '广告主行业',
    type: 'select-tree',
    defaultValue: [],
    config: {
      multiple: true,
      data: [],
      fetchData: (params: any) => getIndustryList({ data: params }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return getIndustry(list);
        }
        return [];
      },
    },
  },
  valid_industry_id_list: { // 过滤废弃行业
    name: 'industry_id_list',
    title: '广告主行业',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      fetchData: (params: any) => getIndustryList({ data: params }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return getIndustry(list, true);
        }
        return [];
      },
    },
  },
  area_code_list: {
    name: 'area_code_list',
    title: '地区',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      fetchData: (params: any) => getAreaCodeList({ data: params }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          const { items } = getAreaInfo(list);
          return items || [];
        }
        return [];
      },
    },
  },
  area_code: {
    name: 'area_code',
    title: '地域',
    type: 'select-tree',
    config: {
      multiple: false,
      selectTarget: 'child',
      data: [],
      fetchData: (params: any) => getAreaCodeList({ data: params }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          const { items } = getAreaInfo(list);
          return items || [];
        }
        return [];
      },
    },
  },
  fund_type: {
    name: 'fund_type',
    title: '资金类型',
    type: 'select',
    config: {
      multiple: true,
      data: [],
      checkAllLabel: '全选',
    },
  },
  app_id_filter: {
    name: 'app_id_filter',
    title: '资金账户名称',
    type: 'select',
    config: {
      multiple: true,
      checkAllLabel: '全选',
      data: [],
    },
  },
  finance_operation_types: {
    name: 'finance_operation_types',
    title: '操作类型',
    type: 'select',
    config: {
      multiple: true,
      data: FINANCE_OPERATION_TYPE_LIST,
      placeholder: '请选择',
    },
  },
  finance_operation_types_shared_wallet: {
    name: 'finance_operation_types',
    title: '操作类型',
    type: 'select',
    config: {
      multiple: true,
      data: FINANCE_OPERATION_TYPE_SHARED_WALLET_LIST,
      placeholder: '请选择',
    },
  },
  finance_inout_types: {
    name: 'finance_inout_types',
    title: '收支类型',
    type: 'select',
    config: {
      multiple: false,
      data: FINANCE_INOUT_TYPES,
    },
  },
  merge_fund_type_filter: {
    name: 'merge_fund_type_filter',
    title: '资金来源',
    type: 'select',
    defaultValue: 0,
    config: {
      multiple: false,
      data: MERGE_FUND_TYPE_LIST,
    },
  },
  date: {
    name: 'date',
    title: '开户日期',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 183,
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'left',
    },
    nameMap: {
      start_time: 'begin_date',
      end_time: 'end_date',
    },
  },
  // 时间轴 也就是起止时间
  time_axis: {
    name: 'time_axis',
    title: '申请时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'right',
      optionalStartRelativeDays: -9999,
      longestRange: 3650,
    },
    nameMap: {
      start_time: 'from_data',
      end_time: 'end_data',
    },
  },
  buying_type: {
    name: 'buying_type',
    title: '账户类型',
    type: 'select',
    defaultValue: '',
    config: {
      data: BUYING_TYPE_LIST,
    },
    clearable: false,
  },
  buying_type_fast: {
    name: 'buying_type',
    title: '账户类型',
    type: 'select',
    defaultValue: '',
    config: {
      data: BUYING_TYPE_FAST_LIST,
    },
    clearable: false,
  },
  // 授权开户
  authorize_type: {
    name: 'authorize_type',
    title: '授权状态',
    type: 'select',
    defaultValue: '',
    config: {
      data: AUTHORIZE_TYPE_LIST,
    },
  },
  source_buying_type: {
    name: 'source_buying_type',
    title: '复用原账户类型',
    type: 'select',
    defaultValue: '',
    config: {
      data: BUYING_TYPE_FAST_LIST,
    },
    clearable: false,
  },
  customer_status: {
    name: 'customer_status',
    title: '账户状态',
    type: 'select',
    defaultValue: '',
    config: {
      data: CUSTOMER_STATUS_LIST,
    },
    clearable: false,
  },
  forbidden_create_ad_status: {
    name: 'forbidden_create_ad_status',
    title: '账户是否启用',
    type: 'select',
    defaultValue: '',
    config: {
      data: FORBIDDEN_CREATE_AD_STATUS,
    },
    clearable: true,
  },
  merged_status: {
    name: 'merged_status',
    title: '账户状态',
    type: 'select',
    defaultValue: '',
    config: {
      data: MERGED_STATUS_LIST,
    },
    clearable: true,
  },
  collocation_status: {
    name: 'collocation_status',
    title: '托管状态',
    type: 'select',
    defaultValue: '',
    config: {
      data: COLLOCATION_STATUS_LIST,
    },
    clearable: false,
  },
  derive_status: {
    name: 'derive_status',
    title: '自动衍生创意',
    type: 'select',
    defaultValue: '',
    config: {
      data: DERIVE_STATUS_LIST,
    },
    clearable: false,
  },
  is_local_business: {
    name: 'is_local_business',
    title: '附近推账户',
    type: 'select',
    defaultValue: '',
    config: {
      data: IS_LOCAL_BUSINESS_LIST,
    },
    clearable: true,
  },
  advertiser_nearby_type: {
    name: 'advertiser_nearby_type',
    title: '附近推账户',
    type: 'select',
    defaultValue: '',
    config: {
      data: [
        { label: '全部', value: '' },
        { label: '是', value: 1 },
      ],
    },
    clearable: true,
  },
  report_advertiser_nearby_type: {
    name: 'advertiser_nearby_type',
    title: '附近推',
    type: 'button-group',
    defaultValue: 1,
    config: {
      theme: 'light',
      data: [
        { label: '附近推直客', value: 2 },
        { label: '附近推子客', value: 1 },
      ],
    },
    clearable: true,
  },
  impression_affaction_level: {
    name: 'impression_affaction_level',
    title: '账户受到余额/预算影响程度',
    type: 'select',
    defaultValue: '',
    config: {
      data: IMPRESSION_AFFACTION_LEVEL,
    },
    clearable: false,
  },
  balance_status: {
    name: 'balance_status',
    title: '余额状态',
    type: 'select',
    defaultValue: '',
    config: {
      data: BALANCE_STATUS_LIST,
    },
    clearable: false,
  },
  operation_label: {
    name: 'customized_label-1000',
    title: '运营方式',
    type: 'select',
    defaultValue: '',
    config: {
      data: OPERATION_LABEL_LIST,
    },
    clearable: false,
  },
  paytype_label: {
    name: 'customized_label-1002',
    title: '广告主付款类型',
    type: 'select',
    defaultValue: '',
    config: {
      data: PAY_TYPE_LIST,
    },
    clearable: false,
  },
  is_collect_advertiser: {
    name: 'is_collect_advertiser',
    title: '是否收藏',
    type: 'select',
    defaultValue: '',
    config: {
      data: IS_COLLECT_ADVERTISER_LIST,
    },
    clearable: false,
  },
  auto_transfer_valid: {
    name: 'auto_transfer_valid',
    title: '自动转账',
    type: 'select',
    defaultValue: '',
    config: {
      data: AUTO_TRANSFER_VALID_LIST,
    },
    clearable: false,
  },
  predict_remain_days_list: {
    name: 'predict_remain_days_list',
    title: '预计消耗',
    type: 'select',
    config: {
      multiple: true,
      checkAll: true,
      search: false,
      data: PREDICT_REMAIN_DAYS_LIST,
    },
    clearable: false,
  },
  dispatch_date: {
    name: 'dispatch_date',
    title: '分户日期',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 183,
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'left',
    },
    nameMap: {
      start_time: 'responded_begin_date',
      end_time: 'responded_end_date',
    },
  },
  source_uid: {
    name: 'source_uid',
    title: '复用原账户ID',
    type: 'search',
    config: {
      placeholder: '请输入复用原账户ID',
    },
  },
  operation_object_type: {
    name: 'operation_object_type',
    title: '操作对象类型',
    type: 'select',
    defaultValue: 1,
    config: {
      data: OPERATION_OBJECT_TYPE_LIST,
    },
    clearable: false,
  },
  operation_object_id: {
    name: 'operation_object_id',
    title: (
      <OverlayTrigger
        trigger="hover"
        overlay={
          <PopOver>
            <span>广告主账户：输入UID</span>
            <br />
            <span>服务商账户：输入UID或SPID</span>
            <br />
            <span>员工：输入员工ID</span>
            <br />
            <span>主体账户：输入主体ID</span>
            <br />
            <span>线索：输入线索ID</span>
          </PopOver>
        }
      >
        操作对象
      </OverlayTrigger>
    ),
    type: 'search',
    config: {
      placeholder: '请输入操作对象',
    },
  },
  operation_type: {
    name: 'operation_type',
    title: '操作类型',
    type: 'select',
    defaultValue: '',
    config: {
      data: OPERATION_TYPE_LIST,
    },
    clearable: false,
  },
  // 通用时间段选择，使用时可以改 title, name
  common_date_range: {
    name: 'common_date_range',
    title: '时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 62,
      useShortcut: true,
      shortcuts: _.filter(SHORTCUTSCONFIG, (v) => v.label !== '本季度'),
    },
    nameMap: {
      start_time: 'begin_time',
      end_time: 'end_time',
    },
  },
  operation_time: {
    name: 'time',
    title: '操作时间',
    type: 'date-picker',
    defaultValue: {
      start_time: date.format('YYYY-MM-DD'),
      end_time: date.format('YYYY-MM-DD'),
    },
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 62,
      useShortcut: true,
      shortcuts: _.filter(SHORTCUTSCONFIG, (v) => v.label !== '本季度'),
    },
    nameMap: {
      start_time: 'begin_time',
      end_time: 'end_time',
    },
    clearable: false,
  },
  advertisertype_agency: {
    name: 'advertisertype_agency',
    title: '账户操作类型',
    type: 'select',
    defaultValue: 'RECHARGE',
    config: {
      data: FINANCE_OPERATION_MP_AGENCY_LIST,
      horizontalPosition: 'left',
    },
    clearable: false,
  },
  advertisertype_advertiser: {
    name: 'advertisertype_advertiser',
    title: '账户操作类型',
    type: 'select',
    defaultValue: 'TRANSFER',
    config: {
      data: FINANCE_OPERATION_MP_AD_LIST,
    },
    clearable: false,
  },
  financeRecordTypes: {
    name: 'finance_record_types',
    title: '记录类型',
    type: 'select',
    defaultValue: [1],
    config: {
      data: FINANCERECORDTYPES_LIST,
    },
    clearable: false,
  },
  nick_name_fuzzy: {
    name: 'nick_name_fuzzy',
    title: '账户名称',
    type: 'search',
    config: {
      placeholder: '请输入账户名称',
    },
  },
  operation_date: {
    name: 'operation_date',
    title: '操作日期',
    type: 'date-picker',
    defaultValue: {
      start_time: date.format('YYYY-MM-DD'),
      end_time: date.format('YYYY-MM-DD'),
    },
    config: {
      useNewUI: true,
      type: 'range',
      // longestRange: 2000,
      longestRange: 61,
      optionalStartDate: '2000-01-01',
      useShortcut: true,
      shortcuts: _.filter(SHORTCUTSCONFIG, (v) => v.label !== '本季度'),
    },
    nameMap: {
      start_time: 'begin_date',
      end_time: 'end_date',
    },
    clearable: false,
  },
  daily_report_date: {
    name: 'daily_report_date',
    title: '日期',
    type: 'date-picker',
    defaultValue: {
      start_time: dayjs(new Date()).add(-7, 'day')
        .format('YYYY-MM-DD'),
      end_time: dayjs(new Date()).add(-1, 'day')
        .format('YYYY-MM-DD'),
    },
    config: {
      useNewUI: true,
      type: 'range',
      optionalEndRelativeDays: -1,
      optionalStartRelativeDays: -365,
      longestRange: 364,
      optionalStartDate: '2020-04-01',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG2.slice(1, 5),
      horizontalPosition: 'left',
    },
    nameMap: {
      start_time: 'begin_date',
      end_time: 'end_date',
    },
    clearable: false,
  },
  daily_report_date_advertiser: {
    name: 'daily_report_date',
    title: '日期',
    type: 'date-picker',
    defaultValue: {
      start_time: dayjs(new Date()).add(-7, 'day')
        .format('YYYY-MM-DD'),
      end_time: dayjs(new Date()).add(-1, 'day')
        .format('YYYY-MM-DD'),
    },
    config: {
      useNewUI: true,
      type: 'range',
      optionalEndRelativeDays: -1,
      optionalStartRelativeDays: -365,
      longestRange: 30,
      optionalStartDate: '2020-04-01',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG2.slice(1, 5),
      horizontalPosition: 'left',
    },
    nameMap: {
      start_time: 'begin_date',
      end_time: 'end_date',
    },
    clearable: false,
  },
  trace_id: {
    name: 'trace_id',
    title: '操作ID',
    type: 'search',
  },
  user_id: {
    name: 'user_id',
    title: '员工ID',
    type: 'search',
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  employee_name: {
    name: 'name',
    title: '员工姓名',
    type: 'search',
  },
  operator_name: {
    name: 'operator_name',
    title: '员工姓名',
    type: 'search',
  },
  username: {
    name: 'username',
    title: '用户名称',
    type: 'search',
    config: {
      placeholder: '用户名称',
    },
  },
  qq_number: {
    name: 'qq_number',
    title: '登录QQ号',
    type: 'search',
  },
  wechat_number: {
    name: 'wechat_number',
    title: '登录微信号',
    type: 'search',
  },
  mobile: {
    name: 'mobile',
    title: '手机号',
    type: 'search',
  },
  role_id_list: {
    name: 'role_id_list',
    title: '角色',
    type: 'select',
    config: {
      multiple: true,
      max: 1,
      data: [],
      fetchData: (params: any) => getRoleList({ data: params }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return _.filter(list, (v) => {
            return v.status === 'ROLE_STATUS_NORMAL';
          }).map((v) => {
            return {
              label: v.name,
              value: v.roleId,
            };
          });
        }
        return [];
      },
    },
  },
  team_id_list: {
    name: 'team_id_list',
    title: '团队',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      placeholder: '请选择团队',
      fetchData: (params: any) => getOrganizationList({ data: params }),
      convertData: (res: any, params: any = {}, item: any, clickLoad = false) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const oldTree = item.config?.data || [];
          const { teams = [] } = data;

          const getTeamTree = (teamTree: any) => {
            const cascadeTree: any = [];
            teamTree.forEach((value: any) => {
              if (value.children && value.children.length) {
                cascadeTree.push({
                  desc: value.name,
                  value: value.teamId,
                  parent_id: value.parentId,
                  options: getTeamTree(value.children),
                  secondTeam: value.secondTeam || false,
                  beginDate: value.beginDate,
                  endDate: value.endDate,
                });
              } else {
                cascadeTree.push({
                  desc: value.name,
                  value: value.teamId,
                  parent_id: value.parentId,
                  secondTeam: value.secondTeam || false,
                  beginDate: value.beginDate,
                  endDate: value.endDate,
                });
              }
            });
            return cascadeTree;
          };

          const getNewTeamTree = (oldTree: any, newTree: any) => {
            const tree = oldTree.map((v: any) => {
              if (v.value === params.parent_team_id) {
                return {
                  ...v,
                  options: newTree,
                };
              }
              if (v.options?.length) {
                return {
                  ...v,
                  options: getNewTeamTree(v.options, newTree),
                };
              }
              return v;
            });
            return tree;
          };

          if (params.parent_team_id && clickLoad) {
            return getNewTeamTree(oldTree, getTeamTree(teams));
          }

          return getTeamTree(teams);
        }
        return [];
      },
      clickLoad: true,
      getClickLoadParams: (v: any) => (v.options?.length ? { parent_team_id: v.value } : null),
    },
  },
  employee_status: {
    name: 'status',
    title: '在职状态',
    type: 'select',
    config: {
      data: EMPLOYEE_STATUS_LIST,
    },
  },
  employee_type: {
    name: 'type',
    title: '员工类型',
    type: 'select',
    config: {
      data: EMPLOYEE_TYPE_LIST,
    },
  },
  account_type: {
    name: 'account_type',
    title: '员工类型',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '员工类型',
    },
  },
  seat_no: {
    name: 'seat_no',
    title: '坐席号',
    type: 'search',
  },
  appid_list: {
    name: 'appid_list',
    title: 'APPID',
    type: 'search',
    config: {
      placeholder: '多个请用英文逗号间隔',
    },
  },
  wxname_list: {
    name: 'wxname_list',
    title: '原始ID',
    type: 'search',
    config: {
      placeholder: '多个请用英文逗号间隔',
    },
  },
  appid: {
    name: 'appid',
    title: 'APP ID',
    type: 'search',
    config: {
      placeholder: '请输入APP ID',
    },
  },
  wxid: {
    name: 'wxid',
    title: '原始 ID',
    type: 'search',
    config: {
      placeholder: '请输入原始 ID',
    },
  },
  uid: {
    name: 'uid',
    title: '账户ID',
    type: 'search',
    config: {
      placeholder: '请输入账户ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  cid: {
    name: 'cid',
    title: '计划ID',
    type: 'search',
    config: {
      placeholder: '请输入计划ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  aid: {
    name: 'aid',
    title: '广告ID',
    type: 'search',
    config: {
      placeholder: '请输入广告ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  enterprise_name_list: {
    name: 'enterprise_name_list',
    title: '主体名称',
    type: 'search',
    config: {
      placeholder: '多个请用英文逗号间隔',
    },
  },
  uname_list: {
    name: 'uname_list',
    title: '广告主名称',
    type: 'search',
    config: {
      placeholder: '多个请用英文逗号间隔',
    },
  },
  is_self_manage_fund: {
    name: 'is_self_manage_fund',
    title: '支持广告主资金自理',
    type: 'select',
    config: {
      data: BOOL_LIST,
    },
  },
  is_cross_k_frame_transfer: {
    name: 'is_cross_k_frame_transfer',
    title: '支持广告主跨框转账',
    type: 'select',
    config: {
      data: BOOL_LIST,
    },
  },
  advertiser_bm_id: {
    name: 'advertiser_bm_id',
    title: '所属商务管家',
    type: 'select',
    config: {
      data: [],
      fetchData: (params: any) => getBmList({ data: params }),
      convertData: (res: any) => {
        const { code, data = [] } = res;
        if (res?.code === 0) {
          return res?.data?.list?.map((v: any) => ({
            label: `${v.advertiser_bm_id}(${v.advertiser_bm_name})`,
            value: v.advertiser_bm_id,
          }));
        }
      },
      search: true,
      getSearchParams: (keyword: any) => ({ keyword }),
    },
  },
  uid_list: {
    name: 'uid_list',
    title: '账户ID',
    ...FILTER_TEMPLATE.numArray,
  },
  uid_list_arr: {
    name: 'uid_list',
    title: '账户ID',
    ...FILTER_TEMPLATE.numArray,
    convertValue: (value: string, item: any) => ({
      [item.name]: value?.replace(/\s+/g, '').split(',')
        .filter((v: string) => v)
        .map((v: string) => Number(v)),
    }),
  },
  // 子客违规查询筛选
  order_id_list: {
    name: 'order_id_list',
    title: '违规单ID',
    type: 'search',
    config: {
      placeholder: '多个请用英文逗号间隔',
    },
    convertValue: (value: string, item: any) => ({
      [item.name]: value?.replace(/\s+/g, '').split(',')
        .filter((v: string) => v),
    }),
  },
  illegal_order_id: {
    name: 'illegal_order_id',
    title: '违规单ID',
    type: 'search',
    config: {
      placeholder: '请输入违规单ID',
    },
  },
  illegal_time: {
    name: 'illegal_time',
    title: '违规日期',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 183,
      useShortcut: true,
      horizontalPosition: 'left',
    },
    nameMap: {
      start_time: 'illegal_start_time',
      end_time: 'illegal_end_time',
    },
  },
  illegal_node_list: {
    name: 'illegal_node_list',
    title: '违规节点/对象',
    type: 'select-tree',
    config: {
      multiple: true,
      fetchData: () => getPunishmentConfig(),
      convertData: (res: any) => res?.data?.illegal_node_list || [],
    },
  },
  punish_time: {
    name: 'punish_time',
    title: '处罚日期',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 183,
      useShortcut: true,
      horizontalPosition: 'right',
    },
    nameMap: {
      start_time: 'start_time',
      end_time: 'end_time',
    },
  },
  action_type_list: {
    name: 'action_type_list',
    title: '账户处罚',
    type: 'select',
    config: {
      multiple: true,
      fetchData: () => getPunishmentConfig(),
      convertData: (res: any) => Object.keys(res?.data?.action_type || {}).map((v) => ({
        value: v,
        label: res.data.action_type[v],
      })),
    },
  },
  level_list: {
    name: 'level_list',
    title: '处罚等级',
    type: 'select',
    defaultValue: '',
    config: {
      multiple: true,
      fetchData: () => getPunishmentConfig(),
      convertData: (res: any) => Object.keys(res?.data?.punish_level || {}).map((v) => ({
        value: v,
        label: res.data.punish_level[v],
      })),
    },
  },
  illegal_scene_list: {
    name: 'illegal_scene_list',
    title: '处罚场景',
    type: 'select-tree',
    config: {
      multiple: true,
      selectTarget: 'child',
      isAutoCheckedParent: false,
      fetchData: () => getPunishmentConfig(),
      convertData: (res: any) => res?.data?.illegal_scene_list || [],
    },
  },
  yesterday_balance: {
    name: 'yesterday_balance',
    title: '不包括虚拟金的余额',
    type: 'number-range',
    config: {
      min: 0,
    },
  },
  balance_available_days: {
    name: 'balance_available_days',
    title: '余额可用天数',
    type: 'number-range',
    config: {
      min: 0,
      max: 366,
    },
  },
  // 账户资质
  need_add_certification: {
    name: 'need_add_certification',
    title: '需账户资质',
    type: 'select',
    config: {
      data: [
        { value: '', label: '全部' },
        { value: 1, label: '仅需补充资质' },
      ],
    },
  },
  // 对公验证
  need_pay_check: {
    name: 'need_pay_check',
    title: '需对公验证',
    type: 'select',
    config: {
      data: [
        { value: '', label: '全部' },
        { value: 1, label: '仅需对公验证' },
      ],
    },
  },
  inactive_days: {
    name: 'inactive_days',
    title: '无投放天数',
    type: 'select',
    config: {
      data: INACTIVE_DAYS_LIST,
    },
  },
  report_date: {
    name: 'report_date',
    title: '日期范围',
    type: 'date-picker',
    defaultValue: {
      start_time: dayjs(new Date()).format('YYYY-MM-DD'),
      end_time: dayjs(new Date()).format('YYYY-MM-DD'),
    },
    config: {
      type: 'range',
      useNewUI: true,
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'left',
      optionalStartDate: '2019-08-01',
    },
    nameMap: {
      start_time: 'begin_date',
      end_time: 'end_date',
    },
    clearable: false,
  },
  bill_month: {
    name: 'bill_month',
    title: '应收发生月',
    type: 'date-picker',
    defaultValue: {
      start_time: dayjs(new Date()).add(-11, 'month')
        .format('YYYY-MM'),
      end_time: dayjs(new Date()).format('YYYY-MM'),
    },
    config: {
      useNewUI: true,
      type: 'range',
      picker: 'month',
      format: 'XXXX-XX',
      showFormat: 'XXXX-XX',
      optionalStartRelativeDays: -9999,
    },
    nameMap: {
      start_time: 'bill_month_begin',
      end_time: 'bill_month_end',
    },
    clearable: false,
  },
  quarter_due_date: {
    name: 'quarter_due_date',
    title: '最晚还款日',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      optionalEndRelativeDays: 365,
    },
    nameMap: {
      start_time: 'quarter_due_date_begin',
      end_time: 'quarter_due_date_end',
    },
    clearable: true,
  },
  receivable_id: {
    name: 'receivable_id',
    title: '应收编号',
    type: 'search',
    config: {
      placeholder: '请输入应收编号',
    },
  },
  plan_id: {
    name: 'plan_id',
    title: '排期ID',
    type: 'search',
    config: {
      placeholder: '请输入排期ID',
    },
  },
  pro_name: {
    name: 'pro_name',
    title: '排期名称',
    type: 'search',
    config: {
      placeholder: '请输入排期名称',
    },
  },
  sub_account_id: {
    name: 'sub_account_id',
    title: '子客ID',
    type: 'search',
    config: {
      placeholder: '请输入子客ID',
    },
  },
  sub_account_name: {
    name: 'sub_account_name',
    title: '子客名称',
    type: 'search',
    config: {
      placeholder: '请输入子客名称',
    },
  },
  receipt_no: {
    name: 'receipt_no',
    title: '交易流水号',
    type: 'search',
    config: {
      placeholder: '请输入交易流水号',
    },
  },
  receipt_date: {
    name: 'receipt_date',
    title: '还款时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
    },
    nameMap: {
      start_time: 'receipt_date_begin',
      end_time: 'receipt_date_end',
    },
    clearable: true,
  },
  k_frame: {
    name: 'k_frame',
    title: 'K框',
    type: 'select',
    defaultValue: '',
    config: {
      data: K_FRAME_LIST,
      fetchData: () => getRainbowCommonConfig('k_frame_config'),
      convertData: (res: any) => {
        return res.config || [];
      },
    },
    clearable: true,
  },
  group_name: {
    name: 'group_name',
    title: '广告主集团',
    type: 'search',
    config: {
      placeholder: '请输入广告主集团',
    },
  },
  advertiser_id: {
    name: 'advertiser_id',
    title: '广告主ID',
    type: 'search',
    config: {
      placeholder: '请输入广告主ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  advertiser_account_id: {
    name: 'advertiser_account_id',
    title: '关联直客账户ID',
    type: 'search',
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  advertiser_name: {
    name: 'advertiser_name',
    title: '广告主名称',
    type: 'search',
    config: {
      placeholder: '请输入广告主名称',
    },
  },
  advertiser_name_list: {
    name: 'advertiser_name',
    title: '广告主名称',
    type: 'search',
    config: {
      placeholder: '空格/英文逗号区分',
    },
    convertValue: (value: string, item: any) => ({
      [item.name]: value?.replace(/\s+|，/g, ',').split(',')
        .filter((v: string) => v),
    }),
  },
  illegal_level_list: {
    name: 'illegal_level_list',
    title: '处罚等级',
    type: 'select',
    config: {
      multiple: true,
      data: [],
    },
    clearable: true,
  },
  illegal_level: {
    name: 'illegal_level',
    title: '处罚等级',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '处罚等级',
    },
    clearable: true,
  },
  illegal_time_range: {
    name: 'illegal_time_range',
    title: '处罚时间',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 183,
      useShortcut: true,
      horizontalPosition: 'left',
    },
  },
  complaint_status: {
    name: 'complaint_status',
    title: '申述状态',
    type: 'select',
    config: {
      data: [],
    },
  },
  reason: {
    name: 'reason',
    title: '处罚原因',
    type: 'search',
    config: {
      placeholder: '请输入处罚原因',
    },
  },
  finance_report_date: {
    name: 'date',
    title: '日期',
    type: 'date-picker',
    defaultValue: {
      start_time: dayjs(new Date()).format('YYYY-MM-DD'),
      end_time: dayjs(new Date()).format('YYYY-MM-DD'),
    },
    config: {
      type: 'range',
      useShortcut: true,
      shortcuts: [
        { startRelativeDate: 0, endRelativeDate: 0, label: '今天' },
        { startRelativeDate: -1, endRelativeDate: -1, label: '昨天' },
        { startRelativeDate: -6, endRelativeDate: 0, label: '最近7天' },
        { startRelativeMonth: 0, endRelativeMonth: 0, endRelativeDate: 0, label: '本月' },
        { startRelativeDate: -29, endRelativeDate: 0, label: '最近30天' },
      ],
      horizontalPosition: 'right',
      optionalStartDate: '2021-01-01',
      longestRange: 30,
    },
    nameMap: {
      start_time: 'begin_date',
      end_time: 'end_date',
    },
    clearable: false,
  },
  manager: {
    title: '主要运营人员',
    name: 'user_id_list',
    type: 'select',
    config: {
      data: [],
      multiple: true,
      clear: true,
      placeholder: '请选择主要运营人员',
      searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
      fetchData: (params: any) => getOperatorList({
        data: {
          ...params,
          agency_uid: globalStore.account.agency_uid, // 报表是主体维度，不能指定服务商
          operator_role: 'AGENCYOPERATORROLE_AGENT_OPERATOR',
          page: 1,
          page_size: 100,
        },
      }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return list.map((v: any) => ({
            ...v,
            label: v.operator_name,
            value: v.user_id,
          }));
        }
        return [];
      },
      search: true,
      getSearchParams: (keywords: any) => ({ filter: keywords }),
    },
  },
  user_id_select: {
    title: '员工',
    name: 'user_id',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '请选择员工',
      searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
      fetchData: (params: any) => getOperatorList({
        data: {
          ...params,
          agency_uid: globalStore.account.agency_uid, // bm维度时为0
          page: 1,
          page_size: 100,
        },
      }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return list.map((v: any) => ({
            ...v,
            label: v.operator_name,
            value: v.user_id,
          }));
        }
        return [];
      },
      search: true,
      getSearchParams: (keywords: any) => ({ filter: keywords }),
    },
  },
  cost_type_array: {
    name: 'cost_type_array',
    title: '购买方式',
    type: 'select',
    tip: '请选择筛选项，选择后表格才有值，下载才会有字段',
    config: {
      multiple: true,
      data: COST_TYPE_LIST,
    },
    clearable: true,
  },
  product_type_list: {
    name: 'product_type_list',
    title: '推广目标',
    type: 'select',
    tip: '请选择筛选项，选择后表格才有值，下载才会有字段',
    config: {
      multiple: true,
      data: [],
      fetchData: () => getProductTypeList(),
      convertData: (res: any) => {
        return res?.data?.list?.map((v: any) => ({
          value: v.product_type_array,
          label: v.product_type_name,
        })) || [];
      },
      search: true,
      getSearchParams: (keywords: any) => ({ filter: keywords }),
    },
    clearable: true,
  },
  report_cost_type_array: {
    name: 'cost_type_array',
    title: '购买方式',
    type: 'groupby-checkbox-group',
    config: {
      group_by: 'cost_type',
      checkAll: true,
      data: COST_TYPE_LIST,
      CheckboxProps: {
        inputTip: '勾选“全选”，包含页面展示的购买方式，若需要全量数据，请不要勾选，直接下载',
        inputTipArea: 'all',
      },
    },
  },
  report_product_type_list: {
    name: 'product_type_list',
    title: '推广目标',
    type: 'groupby-checkbox-group',
    config: {
      group_by: 'product_type',
      checkAll: true,
      data: [],
      fetchData: () => getProductTypeList(),
      convertData: (res: any) => {
        return res?.data?.list?.map((v: any) => ({
          ...v,
          value: `${v.product_type_array.join(',')}`,
          label: v.product_type_name,
          inputTip: '',
        })) || [];
      },
      CheckboxProps: {
        inputTip: '勾选“全选”，包含页面展示的推广目标，若需要全量数据，请不要勾选，直接下载',
        inputTipArea: 'all',
      },
    },
  },
  report_placement_group_list: {
    name: 'placement_group_id_list',
    title: '投放版位',
    type: 'groupby-checkbox-group',
    config: {
      group_by: 'placement_group_id',
      checkAll: true,
      data: [],
      fetchData: () => getPlacementGroupList(),
      convertData: (res: any) => {
        return res?.data?.list?.map((v: any) => ({
          ...v,
          value: `${v.placement_group_id_array.join(',')}`,
          label: v.placement_group_name,
          inputTip: '',
        })) || [];
      },
      getDisplayData: (data: Array<any>) => {
        return data?.filter((v) => v.is_show) || [];
      },
      CheckboxProps: {
        inputTip: '勾选“全选”，包含页面展示的投放版位，若需要全量数据，请不要勾选，直接下载',
        inputTipArea: 'all',
      },
    },
  },
  report_position_list: {
    name: 'position_id_list',
    title: '广告位',
    type: 'groupby-checkbox-group',
    config: {
      group_by: 'position_id',
      checkAll: true,
      data: [],
      fetchData: () => getPositionList(),
      convertData: (res: any) => {
        return res?.data?.list?.map((v: any) => ({
          ...v,
          value: v.position_id,
          label: v.position_name,
          inputTip: '',
        })) || [];
      },
      CheckboxProps: {
        inputTip: '勾选“全选”，包含页面展示的广告位，若需要全量数据，请不要勾选，直接下载',
        inputTipArea: 'all',
      },
    },
  },
  agency_report_groupby: {
    name: 'group_by_list',
    title: '统计维度',
    type: 'groupby-checkbox-group',
    defaultValue: ['stats_date', 'agency_uid'],
    config: {
      checkAll: true,
      data: [
        { value: 'stats_date', label: '时间', disabled: true },
        { value: 'agency_uid', label: '所属服务商' },
        { value: 'manager', label: '主要运营人员' },
        { value: 'industry_id', label: '广告主行业' },
      ],
    },
  },
  ad_dimension: {
    name: 'dimension',
    title: '广告维度',
    type: 'button-group',
    defaultValue: 'cid',
    config: {
      theme: 'light',
      data: [
        { value: 'cid', label: '推广计划' },
        { value: 'aid', label: '广告' },
      ],
    },
  },
  advertiser_report_combined_filter: {
    name: 'name_search_type',
    type: 'name-combined-filter',
    config: {
      data: [{
        label: '账户名称',
        value: 'uname',
        type: 'input',
        config: {
          placeholder: '请输入账户名称',
        },
      }, {
        label: '账户ID',
        value: 'uid',
        type: 'input',
        config: {
          placeholder: '请输入账户ID',
        },
      }, {
        label: '原始ID',
        value: 'wxid',
        type: 'input',
        config: {
          placeholder: '请输入原始ID',
        },
      }, {
        label: 'APP ID',
        value: 'appid',
        type: 'input',
        config: {
          placeholder: '请输入APP ID',
        },
      }],
    },
  },
  ad_report_combined_filter: {
    name: 'name_search_type',
    type: 'name-combined-filter',
    config: {
      data: [{
        label: '账户名称',
        value: 'uname',
        type: 'input',
        config: {
          placeholder: '请输入账户名称',
        },
      }, {
        label: '账户ID',
        value: 'uid',
        type: 'input',
        config: {
          placeholder: '请输入账户ID',
        },
      }, {
        label: '广告ID',
        value: 'aid',
        type: 'input',
        config: {
          placeholder: '请输入广告ID',
        },
      }, {
        label: '推广计划ID',
        value: 'cid',
        type: 'input',
        config: {
          placeholder: '请输入推广计划ID',
        },
      }],
    },
  },
  partition_quarter: {
    name: 'partition_quarter',
    title: '日期范围',
    type: 'select',
    defaultValue: `${dayjs().year()}Q${dayjs().quarter()}`,
    config: {
      data: getQTDList(new Date('2022-10-01')),
    },
    clearable: false,
  },
  spu_source: {
    name: 'spu_source',
    title: '商品创建来源',
    type: 'select',
    config: {
      data: [],
    },
    clearable: true,
  },
  spu_category_full: {
    name: 'spu_category',
    title: '商品类目',
    type: 'select-tree',
    config: {
      multiple: true,
      clear: true,
      fetchData: () => getSpuCategoryList({ is_full: true }),
      convertData: (res: any) => convertSpuCategoryList(res.data),
    },
  },
  permission_ids: {
    name: 'permission_ids',
    title: '权限ID',
    ...FILTER_TEMPLATE.numArray,
  },
  permission_name: {
    name: 'permission_name',
    title: '权限名称',
    type: 'search',
    config: {
      placeholder: '请输入权限名称',
    },
  },
  time_line: {
    name: 'time_line',
    title: '数据口径',
    type: 'select',
    defaultValue: 1,
    config: {
      data: [
        { value: 1, label: '播放口径' },
        { value: 2, label: '上报口径' },
        { value: 3, label: '激活口径' },
      ],
    },
    clearable: false,
  },
  account_remark: {
    name: 'account_remark',
    title: '备注',
    type: 'search',
    config: {
      placeholder: '请输入账户备注',
    },
  },
  account_group: {
    name: 'group_id',
    title: '分组',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择账户分组',
    },
  },
  valid_account_only: {
    name: 'valid_account_only',
    title: '过滤无数据',
    type: 'select',
    defaultValue: 1,
    config: {
      data: [
        { value: 1, label: '是' },
        { value: 0, label: '否' },
      ],
    },
    clearable: false,
  },
  monitor_name: {
    name: 'monitor_name',
    title: '规则名称',
    type: 'search',
    config: {
      placeholder: '请输入规则名称',
    },
  },
  rule_types: {
    name: 'rule_types',
    title: '预警规则',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      data: [
        { value: 'AUTO_ACQUISITION', label: '可开启一键起量广告的提醒' },
        { value: 'NEED_COPY', label: '需要复制的广告提醒' },
        { value: 'NEED_STOP', label: '需要暂停广告的提醒' },
        { value: 'NEED_CHANGE_PRICE', label: '需要调价广告的提醒' },
        { value: 'OVER_COST', label: '超成本广告提醒' },
        { value: 'LOW_COST', label: '掉量广告提醒' },
        { value: 'NEED_START_AGAIN', label: '需要再被开启的暂停广告提醒' },
        { value: 'NEED_CHANGE_DAY_BUDGET', label: '需要调整日预算的账户提醒' },
      ],
    },
    clearable: true,
  },
  object_type: {
    name: 'object_type',
    title: '监控对象',
    type: 'select',
    defaultValue: '',
    config: {
      data: [
        { value: 2, label: '广告' },
        { value: 1, label: '账户' },
      ],
    },
    clearable: true,
  },
  diagnose_type_list: {
    name: 'diagnose_type_list',
    title: '诊断类型',
    type: 'select',
    config: {
      multiple: true,
      checkAll: true,
      data: [],
      fetchData: () => getRainbowCommonConfig('diagnose_config'),
      convertData: (res: any) => {
        return Object.keys(res?.diagnose_type || {}).map((value) => ({ value, label: res?.diagnose_type?.[value] }));
      },
    },
    clearable: true,
  },
  link_person_status: {
    name: 'link_person_status',
    title: '联系人状态',
    type: 'select',
    config: {
      data: [
        { value: 'LINK_PERSON_STATUS_NEED_SUPPLY', label: '待补充联系人' },
        { value: 'LINK_PERSON_STATUS_APPROVING', label: '联系人审核中' },
        { value: 'LINK_PERSON_STATUS_REJECT', label: '联系人审核拒绝' },
        { value: 'LINK_PERSON_STATUS_APPROVED', label: '联系人审核通过' },
      ],
    },
    clearable: true,
  },
  identity_verify_real_result: {
    name: 'identity_verify_real_result',
    title: '对公状态',
    type: 'select',
    config: {
      data: [
        { value: 'IDENTITY_VERIFY_REAL_RESULT_TODO', label: '待进行身份验证' },
        { value: 'IDENTITY_VERIFY_REAL_RESULT_PASS', label: '已完成身份验证' },
      ],
    },
    clearable: true,
  },
  identity_verify_status: {
    name: 'identity_verify_status',
    title: '对公状态',
    type: 'select',
    config: {
      data: [
        { value: 'IDENTITY_VERIFY_STATUS_NOT_VALID', label: '身份验证已过期或未验证' },
        { value: 'IDENTITY_VERIFY_STATUS_NEAR', label: '身份验证有效期不足60天' },
        { value: 'IDENTITY_VERIFY_STATUS_ENOUGH', label: '身份验证有效期大于60天' },
      ],
    },
    clearable: true,
  },
  business_unit_id_select: {
    title: '所属业务单元',
    name: 'business_unit_id',
    type: 'select',
    config: {
      data: [],
      clear: true,
      placeholder: '请选择所属业务单元',
      fetchData: (params: any) => getBusinessUnitList({
        ...params,
        page: 1,
        page_size: 50,
      }),
      convertData: (res: any) => {
        return (res?.data?.list || []).map((v: any) => ({
          label: `${v.business_unit_name}(${v.business_unit_id})`,
          value: v.business_unit_id,
        }));
      },
      search: true,
      getSearchParams: (keywords: any) => ({ keyword: keywords }),
    },
  },
  agency_type: {
    name: 'agency_type',
    title: '所属服务商类型',
    type: 'select',
    config: {
      data: [
        { value: AgencyType.normal, label: '普通帐号' },
        { value: AgencyType.child, label: '子帐号' },
      ],
    },
  },
  paid_type: {
    name: 'paid_type',
    title: '开票类型',
    type: 'select',
    defaultValue: 1,
    config: {
      data: PAID_TYPE_LIST,
    },
    clearable: false,
  },
  exist_wallet_id: {
    name: 'exist_wallet_id',
    title: '是否绑定共享钱包',
    type: 'select',
    config: {
      data: BOOL_LIST,
    },
    clearable: true,
  },
  is_store_flow: {
    name: 'is_store_flow',
    title: '是否门店通',
    type: 'select',
    defaultValue: '全部',
    config: {
      data: [
        { value: '全部', label: '全部' },
        { value: '是', label: '是' },
      ],
    },
    clearable: true,
  },
  mdm_name: {
    name: 'mdm_name',
    title: '客户主体名称',
    type: 'search',
    config: {
      placeholder: '请输入客户主体名称',
    },
  },
  accumulated_types: {
    name: 'accumulated_types',
    title: '被动验证类型',
    type: 'search',
    config: {
      placeholder: '请输入被动验证类型',
    },
  },
  approve_time: {
    name: 'approve_time',
    title: '公示时间范围',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      longestRange: 183,
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'left',
      optionalStartDate: '2025-10-15',
    },
    nameMap: {
      start_time: 'approve_time_start',
      end_time: 'approve_time_end',
    },
  },
  batch_quarter: {
    name: 'batch_quarter',
    title: '归属季度范围',
    type: 'select',
    defaultValue: [],
    config: {
      multiple: true,
      max: 2,
      data: getQuarterList('2025-10-15').reverse(),
      setValueLabel: (value: any) => {
        const list = Object.keys(value || {});
        list.sort();
        if (list.length === 2) {
          return `${list[0]}-${list[1]}`;
        }
        if (list.length === 1) {
          return list[0];
        }
        return '';
      },
    },
    clearable: true,
  },
  agent_name: {
    name: 'agent_name',
    title: '主体名称',
    type: 'search',
    config: {
      placeholder: '请输入主体名称',
    },
  },
  agent_group: {
    name: 'agent_group',
    title: '集团名称',
    type: 'search',
    config: {
      placeholder: '请输入集团名称',
    },
  },
  ...filterRebate,
  ...filterSales,
  ...filterDistribution,
  ...filterTask,
  ...filterManage,
  ...filterReport,
  ...filterCreative,
  ...filterGrowup,
};

const getOperatorTypeConfig = (payloads: any) => ({
  user_id: {
    label: '运营人员',
    value: 'user_id',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择运营人员',
      searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
      fetchData: (params: any) => (getOperatorList({
        data: {
          ...(_.isArray(payloads?.agency_uid_list) && {
            agency_uid_list: payloads?.agency_uid_list,
          }),
          ...params,
          operator_role: 'AGENCYOPERATORROLE_AGENT_OPERATOR',
          page: 1,
          page_size: 100,
        },
      })),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            { label: '全部', value: '' },
            ...list.map((v: any) => ({
              ...v,
              label: v.operator_name,
              value: v.user_id,
            })),
          ];
        }
        return [];
      },
      search: true,
      getSearchParams: (keywords: any) => ({ filter: keywords }),
    },
  },
  master_user_id: {
    label: '主要运营人员',
    value: 'master_user_id',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择主要运营人员',
      searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
      fetchData: (params: any) => getOperatorList({
        data: {
          ...(_.isArray(payloads?.agency_uid_list) && {
            agency_uid_list: payloads?.agency_uid_list,
          }),
          ...params,
          operator_role: 'AGENCYOPERATORROLE_AGENT_OPERATOR',
          page: 1,
          page_size: 100,
        },
      }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            { label: '全部', value: '' },
            ...list.map((v: any) => ({
              ...v,
              label: v.operator_name,
              value: v.user_id,
            })),
          ];
        }
        return [];
      },
      search: true,
      getSearchParams: (keywords: any) => ({ filter: keywords }),
    },
  },
  design_user_id: {
    label: '设计师',
    value: 'design_user_id',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择设计师',
      searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
      fetchData: (params: any) => getOperatorList({
        data: {
          ...(_.isArray(payloads?.agency_uid_list) && {
            agency_uid_list: payloads?.agency_uid_list,
          }),
          ...params,
          operator_role: 'AGENCYOPERATORROLE_AGENCY_DESIGNER',
          page: 1,
          page_size: 100,
        },
      }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            { label: '全部', value: '' },
            ...list.map((v: any) => ({
              ...v,
              label: v.operator_name,
              value: v.user_id,
            })),
          ];
        }
        return [];
      },
      search: true,
      getSearchParams: (keywords: any) => ({ filter: keywords }),
    },
  },
  sale_user_id: {
    label: '维护销售',
    value: 'sale_user_id',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择维护销售',
      searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
      fetchData: (params: any) => getOperatorList({
        data: {
          ...(_.isArray(payloads?.agency_uid_list) && {
            agency_uid_list: payloads?.agency_uid_list,
          }),
          ...params,
          operator_role: 'SALE_OPERATORROLE_TYPE',
          page: 1,
          page_size: 100,
        },
      }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            { label: '全部', value: '' },
            ...list.map((v: any) => ({
              ...v,
              label: v.operator_name,
              value: v.user_id,
            })),
          ];
        }
        return [];
      },
      search: true,
      getSearchParams: (keywords: any) => ({ filter: keywords }),
    },
  },
  master_sale_user_id: {
    label: '主要维护销售',
    value: 'master_sale_user_id',
    type: 'select',
    config: {
      data: [],
      placeholder: '请选择主要维护销售',
      searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
      fetchData: (params: any) => getOperatorList({
        data: {
          ...(_.isArray(payloads?.agency_uid_list) && {
            agency_uid_list: payloads?.agency_uid_list,
          }),
          ...params,
          operator_role: 'SALE_OPERATORROLE_TYPE',
          page: 1,
          page_size: 100,
        },
      }),
      convertData: (res: any) => {
        const { code, data = {} } = res;
        if (code === 0) {
          const { list = [] } = data;
          return [
            { label: '全部', value: '' },
            ...list.map((v: any) => ({
              ...v,
              label: v.operator_name,
              value: v.user_id,
            })),
          ];
        }
        return [];
      },
      search: true,
      getSearchParams: (keywords: any) => ({ filter: keywords }),
    },
  },
});

const getMultiFilterMap = (payloads: any) => ({
  operatorType: getOperatorTypeConfig(payloads),
  operatorTypeWithObserver: {
    ...getOperatorTypeConfig(payloads),
    observer_user_id: {
      label: '观察者',
      value: 'observer_user_id',
      type: 'select',
      config: {
        data: [],
        placeholder: '请选择观察者',
        searchFields: ['label', 'value', 'wechat_number', 'qq_number'],
        fetchData: (params: any) => getOperatorList({
          data: {
            ...(_.isArray(payloads?.agency_uid_list) && {
              agency_uid_list: payloads?.agency_uid_list,
            }),
            ...params,
            operator_role: 'AGENCYOPERATORROLE_AGENCY_OBSERVER_OPERATOR',
            page: 1,
            page_size: 100,
          },
        }),
        convertData: (res: any) => {
          const { code, data = {} } = res;
          if (code === 0) {
            const { list = [] } = data;
            return [
              { label: '全部', value: '' },
              ...list.map((v: any) => ({
                ...v,
                label: v.operator_name,
                value: v.user_id,
              })),
            ];
          }
          return [];
        },
        search: true,
        getSearchParams: (keywords: any) => ({ filter: keywords }),
      },
    },
  },
  operators: _.pick(getOperatorTypeConfig(payloads), ['user_id', 'master_user_id']),
  operationOperator: {
    created_user_id: {
      label: '操作人ID',
      value: 'created_user_id',
      type: 'search',
    },
    operator_name: {
      label: '操作人姓名',
      value: 'operator_name',
      type: 'search',
    },
    created_user_id_sale: {
      label: '销售人员',
      value: 'created_user_id_sale',
      type: 'select-tree',
      config: {
        data: [],
        fetchData: (params: any) => Promise.all([
          getSaleOrganizationTree(),
          getSaleEmployeeList({
            data: {
              field: 'USER_NAME',
            },
          }),
        ]),
        convertData: (res: any) => {
          const [organizationTree = {}, { list: employeeList = [] } = {}] = res;
          const getEmployeeNode = (employee: any) => {
            const user = _.find(employeeList, (v) => v.employeeId === employee.userId) || {};
            return {
              value: employee.userId,
              desc: user.operationUserName || employee.name || employee.qqNumber || employee.userId,
            };
          };

          const getTeamNode: any = (team: any) => {
            return {
              value: team.name,
              desc: team.name,
              not_allow_selected: true,
              options: _.concat(
                _.map(team.children, (t) => getTeamNode(t)),
                _.compact(_.map(team.employees, (e) => getEmployeeNode(e))),
              ),
            };
          };

          return _.concat(
            _.map(organizationTree.teams || [], (t) => getTeamNode(t)),
            _.compact(_.map(organizationTree.freeEmployees || [], (e) => getEmployeeNode(e))),
          );
        },
      },
    },
  },
});

export const getFilterMap = (nameData: any, handleNameDataChange: any, payloads: any) => {
  const filterMap: any = {
    ...BASE_FILTER_MAP,
  };
  const MULTI_FILTER_MAP: any = getMultiFilterMap(payloads);
  _.keys(MULTI_FILTER_MAP).forEach((key) => {
    const nameMap = MULTI_FILTER_MAP[key] || {};
    const nameValue = nameData[key] || _.keys(nameMap)[0] || '';
    const item = nameMap[nameValue] || {};

    filterMap[key] = {
      ...item,
      key,
      name: nameValue,
      title: item.label,
      nameMap,
      nameConfig: {
        data: _.values(nameMap),
        onChange: (event: any, value: any) => handleNameDataChange(event, value, key, nameMap),
        ...item.nameConfig || {},
      },
    };
  });

  return filterMap;
};
